module.exports = __webpack_public_path__ + "img/MpcEnergyView.761c093b.png";